import Logger from '../../js/lib/logger';

class TrayBuilderTouch extends HTMLElement {
  #NAME = 'TrayBuilderTouch';
  #abortController: AbortController | null;
  #insertsContainer: HTMLElement;
  #disabled = false;

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    this.#insertsContainer = this.querySelector('svg-inserts-container') as HTMLElement;
  }

  connectedCallback(): void {
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    //
    this.addEventListener('touchstart', (e) => {
      if (e.touches.length > 1 ){
        this.#insertsContainer.dataset.disabled = 'true';
        this.#disabled = true;
      }
    }, { signal });
    //
    this.addEventListener('touchend', () => {
      if (this.#disabled) {
        this.#insertsContainer.dataset.disabled = 'false';
        this.#disabled = false;
      }
    }, { signal });
  }

  disconnectedCallback(): void {
    this.#abortController?.abort();
    this.#abortController = null;
  }

}

customElements.define('tray-builder-touch', TrayBuilderTouch);